import { RegulationsHeaderWrapper } from '~/components/header/regulations-header/index.js';
import HeaderWrapper from './wrapper/header-wrapper.js';
import SearchBarWrapper from './wrapper/search-bar-wrapper.js';
import AppBannerWrapper from './wrapper/app-banner-wrapper.js';
import HeroWrapper from './wrapper/hero-wrapper.js';
import MainWrapper from './wrapper/main-wrapper.js';
import OverlayWrapper from './wrapper/overlay-wrapper.js';
import SidebarWrapper from './wrapper/sidebar-wrapper.js';
import SubWrapper from './wrapper/sub-wrapper.js';
import FooterWrapper from './wrapper/footer-wrapper.js';
import Wrapper from './wrapper/wrapper.js';
import AppWrapper from './wrapper/app-wrapper.js';
import ModalWrapper from './wrapper/modal-wrapper.js';
import BaseLayout from './base-layout.js';

const WRAPPERS = {
	HeaderWrapper,
	SearchBarWrapper,
	AppBannerWrapper,
	HeroWrapper,
	MainWrapper,
	OverlayWrapper,
	SidebarWrapper,
	ModalWrapper,
	SubWrapper,
	FooterWrapper,
	Wrapper,
	AppWrapper,
	RegulationsHeaderWrapper
};

const Layout = ({ routes }) => <BaseLayout routes={routes} wrappers={WRAPPERS} />;
export default Layout;
